import React, {useState} from 'react'
import {Button, Descriptions, Modal} from "antd";
import {getAppointmentById} from "../../services/serviceAppointment";
import userDateFormatter from "../../services/formatters/userDateFormatter";

const AppointmentDetails = ({appointmentId}) => {

    const [detailModal, setDetailModal] = useState(false)
    const [appointment, setAppointment] = useState({})

    const handleDetailClick = () => {
        getAppointmentById(appointmentId)
            .then(({data}) => {
                extractData(data)
                setDetailModal(!detailModal)
            })
    }

    const statusCorrecter = (status) => {
        const statuses = {
            "WAITING": "BEKLEMEDE",
            "NEGATIVE": "OLUMSUZ",
            "POSITIVE": "OLUMLU"
        }

        return statuses[status]
    }

    const extractData = (list) => {
        let obj = {
            customerName: list.customer.name,
            relevantPerson: `${list.relevantPerson.name} ${list.relevantPerson.surname}`,
            createdBy: list.createdBy,
            planningDate: userDateFormatter(list.planningDate),
            createdDate: userDateFormatter(list.createdDate),
            status: statusCorrecter(list.status),
            title: list.title,
            resultText: list.resultText,
            brand: list.hasOwnProperty('brand') && list.brand ? list.brand.code : ''
        }
        setAppointment(obj)
    }

    return(
        <React.Fragment>
            <Button
                type={"link"}
                onClick={() => handleDetailClick()}
            >Detay</Button>

            <Modal
                open={detailModal}
                onCancel={() => setDetailModal(!detailModal)}
                title={'Randevu Detayları'}
                footer={[
                    <Button key={'CancelButton'}  onClick={() => setDetailModal(!detailModal)}>Vazgeç</Button>
                ]}
            >
                <Descriptions bordered>
                    <Descriptions.Item label={'Oluşturan'} span={3}>{appointment.createdBy}</Descriptions.Item>
                    <Descriptions.Item label={'Oluşturma Tarihi'} span={3}>{appointment.createdDate}</Descriptions.Item>
                    <Descriptions.Item label={'Randevu Tarihi'} span={3}>{appointment.planningDate}</Descriptions.Item>
                    <Descriptions.Item label={'Müşteri'} span={3}>{appointment.customerName}</Descriptions.Item>
                    <Descriptions.Item label={'Marka'} span={3}>{appointment.brand}</Descriptions.Item>
                    <Descriptions.Item label={'Konu'} span={3}>{appointment.title}</Descriptions.Item>
                    <Descriptions.Item label={'İlgili'} span={3}>{appointment.relevantPerson}</Descriptions.Item>
                    <Descriptions.Item label={'Durum'} span={3}>{appointment.status}</Descriptions.Item>
                    <Descriptions.Item label={'Sonucu'} span={3}>{appointment.resultText ? appointment.resultText : <span>Sonuç Girilmedi</span>}</Descriptions.Item>
                </Descriptions>
            </Modal>

        </React.Fragment>
    )
}
export default AppointmentDetails